import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { IncidentsModel } from '../../models/incident.models';
import { environment } from '../../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NoResultComponent } from '../../../../components/shared/no-result/no-result.component';

@Component({
  selector: 'app-summary-sports',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NzSkeletonComponent,
    NoResultComponent,
  ],
  templateUrl: './summary-sports.component.html',
  styleUrl: './summary-sports.component.scss',
})
export class SummarySportsComponent {
  incidentsFirstHalf: Array<IncidentsModel> = [];
  incidentsSecondHalf: Array<IncidentsModel> = [];
  incidentsOvertime: Array<IncidentsModel> = [];
  incidentsPenaltys: Array<IncidentsModel> = [];
  infoMatch: any;
  loading = true;
  viewLiveTracker: boolean = false;
  linkLiveTracker: SafeResourceUrl = '';

  urlIMG = environment.urlIMG;

  competition: any;
  competitionLogo: any;
  nameStage: any;

  matchSummary: any = [];

  @Input() set infoMatchSelected(infoMatchSelected: any) {
    this.infoMatch = infoMatchSelected;

    if (this.infoMatch.matchSummary?.homeTeam)
      this.matchSummary = Object.keys(
        this.infoMatch.matchSummary.homeTeam.score
      )
        .reverse()
        .map((key) => {
          if (key !== 'regular') {
            return {
              title: key,
              homeTeamScore: this.infoMatch.matchSummary.homeTeam.score[key],
              awayTeamScore: this.infoMatch.matchSummary.awayTeam.score[key],
            };
          }
          return null;
        })
        .filter((entry) => entry !== null);

    setInterval(() => {
      this.loading = false;
    }, 1000);
  }

  constructor() {}

  goToLink(url: string) {
    window.open(url, '_blank');
  }
}
